export const SITE_URL = 'https://www.petekb2b.com';
export const SUPPORTED_LANGUAGES = ['en', 'tr', 'de', 'ar'];
export const DEFAULT_LANGUAGE = 'en';

export const LOCALE_MAP = {
  en: 'en_US',
  tr: 'tr_TR',
  de: 'de_DE',
  ar: 'ar_SA',
};

export const LANG_PATTERN = new RegExp(`^/(${SUPPORTED_LANGUAGES.join('|')})(/|$)`);

export function getPathWithoutLang(pathname) {
  const stripped = pathname.replace(LANG_PATTERN, '/');
  if (stripped === '/') return '';
  return stripped.endsWith('/') ? stripped.slice(0, -1) : stripped;
}
